/* NinaBoo — tema Shopify. Vanilla JS: cart drawer, add-to-cart, hero slider, nav, galeria. */
(function () {
  "use strict";
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  let maybeShowLeadModal = function () {};

  const money = (cents) =>
    (cents / 100).toLocaleString("pt-BR", { style: "currency", currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "BRL" });

  /* ---------- Cart ---------- */
  const drawer = $("[data-cart-drawer]");
  const panel = $("[data-cart-panel]");
  const overlay = $("[data-cart-overlay]");

  /* Trava de rolagem coordenada: o body só destrava quando NENHUM overlay (drawer,
     modal de lead) está aberto — cada um escrevendo body.overflow por conta própria,
     fechar um deixava o outro no estado errado. */
  let drawerOpen = false, leadOpen = false;
  function syncBodyLock() {
    document.body.style.overflow = (drawerOpen || leadOpen) ? "hidden" : "";
  }
  /* Token no timer de fechamento: reabrir dentro dos 300ms da animação de saída fazia o
     setTimeout antigo esconder o drawer RECÉM-reaberto — sobrava overflow:hidden sem
     overlay visível e a página ficava congelada até um F5. */
  let drawerHideTimer = null;
  function openDrawer() {
    if (!drawer) return;
    clearTimeout(drawerHideTimer);
    drawerOpen = true;
    drawer.classList.remove("hidden");
    /* pointer-events-none SAIU do markup; o remove abaixo cura HTML antigo em cache.
       (pointer-events-auto não existe no CSS compilado — nunca confiar nela.) */
    drawer.classList.remove("pointer-events-none");
    requestAnimationFrame(() => {
      panel && panel.classList.remove("translate-x-full");
      overlay && overlay.classList.remove("opacity-0");
    });
    syncBodyLock();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawerOpen = false;
    panel && panel.classList.add("translate-x-full");
    overlay && overlay.classList.add("opacity-0");
    syncBodyLock();
    clearTimeout(drawerHideTimer);
    drawerHideTimer = setTimeout(() => { drawer.classList.add("hidden"); }, 300);
  }

  function renderCart(cart) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle("hidden", cart.item_count === 0);
    });
    const list = $("[data-cart-items]");
    const empty = $("[data-cart-empty]");
    const footer = $("[data-cart-footer]");
    const tmpl = $("[data-cart-item-template]");
    if (!list || !tmpl) return;
    list.innerHTML = "";
    if (cart.item_count === 0) {
      empty && (empty.style.display = "");
      footer && (footer.hidden = true);
      updateFreeShipBar(cart);
      /* avisa quem depende do carrinho redesenhado (ex.: cross-sell do drawer) —
         MESMO ponto de render, sem 2º ciclo nem polling. */
      document.dispatchEvent(new CustomEvent("nb:cart-rendered", { detail: cart }));
      return;
    }
    empty && (empty.style.display = "none");
    footer && (footer.hidden = false);
    cart.items.forEach((item) => {
      const node = tmpl.content.cloneNode(true);
      const link = $("[data-line-img-link]", node);
      const img = $("[data-line-img]", node);
      const title = $("[data-line-title]", node);
      const variant = $("[data-line-variant]", node);
      const qty = $("[data-line-qty]", node);
      const price = $("[data-line-price]", node);
      link.href = item.url;
      if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2"); }
      img.alt = item.product_title;
      title.textContent = item.product_title;
      title.href = item.url;
      variant.textContent = (item.variant_title && !/default/i.test(item.variant_title)) ? item.variant_title : "";
      qty.textContent = item.quantity;
      price.textContent = money(item.final_line_price);
      $("[data-line-minus]", node).addEventListener("click", () => changeLine(item.key, item.quantity - 1));
      $("[data-line-plus]", node).addEventListener("click", () => changeLine(item.key, item.quantity + 1));
      const rm = $("[data-line-remove]", node);
      rm && rm.addEventListener("click", () => changeLine(item.key, 0));
      list.appendChild(node);
    });
    const sub = $("[data-cart-subtotal]");
    sub && (sub.textContent = money(cart.total_price));
    updateFreeShipBar(cart);
    /* avisa quem depende do carrinho redesenhado (ex.: cross-sell do drawer) —
       MESMO ponto de render, sem 2º ciclo nem polling. */
    document.dispatchEvent(new CustomEvent("nb:cart-rendered", { detail: cart }));
  }

  /* ---------- Barra gamificada de frete grátis ----------
     Atualiza mensagem, preenchimento e MARCOS ao vivo. Quando o frete grátis destrava
     na hora (estava travado e passou a valer), comemora: pulso na barra + confete curto.
     O "estava travado antes" é lido do DOM, não de variável global — o drawer é
     re-renderizado a cada mudança e um flag em memória dispararia comemoração repetida. */
  function updateFreeShipBar(cart) {
    if (!drawer) return;
    const wrap = drawer.querySelector("[data-fs-wrap]");
    if (wrap) wrap.style.display = "";
    const bar = drawer.querySelector("[data-fs-bar]");
    if (!bar) return;

    const num = (attr) => parseInt(bar.getAttribute(attr), 10) || 0;
    const frete = num("data-fs-threshold");
    const bonus = num("data-fs-bonus");
    const meta = num("data-fs-meta") || Math.max(frete, bonus);
    const bonusTexto = bar.getAttribute("data-fs-bonus-texto") || "o próximo bônus";
    if (!meta) return;

    const total = cart.total_price;
    const faltaFrete = frete - total;
    const faltaBonus = bonus - total;
    const pct = Math.min(100, Math.round((total / meta) * 100));

    const fill = bar.querySelector("[data-fs-fill]");
    if (fill) fill.style.width = pct + "%";

    /* a mamadeira viaja na ponta do preenchimento e "chega" quando o frete destrava */
    const rider = bar.querySelector("[data-fs-rider]");
    if (rider) {
      rider.style.left = pct + "%";
      rider.style.opacity = (frete > 0 && frete - total <= 0) ? "0" : "1";
    }

    const msg = bar.querySelector("[data-fs-msg]");
    if (msg) {
      if (frete > 0 && faltaFrete > 0) {
        msg.innerHTML = 'Faltam <span class="font-extrabold text-brand-600">' + money(faltaFrete) +
          '</span> para o <span class="font-bold text-berry-600">frete grátis</span>';
      } else {
        let html = '<span class="font-extrabold text-berry-600">Frete grátis liberado! 🎉</span>';
        if (bonus > 0 && faltaBonus > 0) {
          html += '<span class="mt-0.5 block text-[11px] font-medium text-ink/60">Faltam ' +
            money(faltaBonus) + " para " + bonusTexto + "</span>";
        }
        msg.innerHTML = html;
      }
    }

    /* marcos: apagado -> aceso com check */
    const setNode = (name, atingido, corOn) => {
      const node = bar.querySelector('[data-fs-node="' + name + '"]');
      if (node) {
        node.classList.toggle(corOn, atingido);
        node.classList.toggle("text-white", atingido);
        node.classList.toggle("bg-ink/25", !atingido);
        node.classList.toggle("text-transparent", !atingido);
      }
      const label = bar.querySelector('[data-fs-label="' + name + '"]');
      if (label) {
        const on = name === "frete" ? "text-berry-600" : "text-brand-600";
        label.classList.toggle(on, atingido);
        label.classList.toggle("text-ink/40", !atingido);
      }
    };
    const freteOk = frete > 0 && faltaFrete <= 0;
    setNode("frete", freteOk, "bg-berry");
    setNode("bonus", bonus > 0 && faltaBonus <= 0, "bg-brand-500");

    /* comemoração só na virada */
    const jaComemorou = bar.getAttribute("data-fs-celebrated") === "1";
    if (freteOk && !jaComemorou) {
      bar.setAttribute("data-fs-celebrated", "1");
      celebrate(bar);
    } else if (!freteOk) {
      bar.removeAttribute("data-fs-celebrated");
    }
  }

  /* Confete curto + pulso. CSS injetado uma vez; nada de biblioteca só pra isso.
     Respeita prefers-reduced-motion: quem pediu menos movimento recebe só o pulso. */
  function celebrate(el) {
    if (!document.getElementById("nb-celebrate-css")) {
      const st = document.createElement("style");
      st.id = "nb-celebrate-css";
      st.textContent =
        "@keyframes nb-pulse{0%{box-shadow:0 0 0 0 rgba(22,163,74,.45)}70%{box-shadow:0 0 0 12px rgba(22,163,74,0)}100%{box-shadow:0 0 0 0 rgba(22,163,74,0)}}" +
        ".nb-pulse{animation:nb-pulse .9s ease-out 1}" +
        "@keyframes nb-fall{0%{transform:translate3d(0,0,0) rotate(0);opacity:1}100%{transform:translate3d(var(--dx),90px,0) rotate(var(--rot));opacity:0}}" +
        ".nb-confete{position:absolute;top:8px;width:7px;height:7px;border-radius:2px;pointer-events:none;animation:nb-fall .95s ease-in forwards}";
      document.head.appendChild(st);
    }
    el.classList.remove("nb-pulse");
    void el.offsetWidth;
    el.classList.add("nb-pulse");

    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const cores = ["#e8511c", "#e40057", "#009bb7", "#16a34a", "#fbbf24"];
    const host = el;
    if (getComputedStyle(host).position === "static") host.style.position = "relative";
    for (let i = 0; i < 14; i++) {
      const c = document.createElement("span");
      c.className = "nb-confete";
      c.style.background = cores[i % cores.length];
      c.style.left = 8 + Math.random() * 84 + "%";
      c.style.setProperty("--dx", (Math.random() * 60 - 30).toFixed(0) + "px");
      c.style.setProperty("--rot", (Math.random() * 540 - 270).toFixed(0) + "deg");
      c.style.animationDelay = (Math.random() * 0.18).toFixed(2) + "s";
      host.appendChild(c);
      setTimeout(() => c.remove(), 1300);
    }
  }

  function refreshCart(open) {
    return fetch("/cart.js", { headers: { "Content-Type": "application/json" } })
      .then((r) => r.json())
      .then((cart) => { renderCart(cart); if (open) openDrawer(); return cart; });
  }

  function addToCart(id, qty) {
    /* Drawer abre já — o conteúdo atualiza quando o fetch responde. Antes o clique
       esperava 2 requests em série pra dar qualquer feedback. */
    openDrawer();
    /* O modal de lead NÃO abre mais aqui: ele cobria o drawer recém-aberto (mesmo
       z-50, DOM depois = por cima) e travava o carrinho inteiro. A captação de
       newsletter é do popup do app Shopify Forms (decisão de 2026-08-10). */
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 }),
    })
      .then((r) => r.json())
      .then(() => refreshCart(true))
      .catch(() => { window.location.href = "/cart"; });
  }

  /* Última escrita vence: cliques rápidos em +/− disparavam POSTs concorrentes e a
     resposta mais LENTA (e mais antiga) re-renderizava o carrinho com contagem errada. */
  let cartOpSeq = 0;
  function changeLine(key, quantity) {
    const seq = ++cartOpSeq;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    })
      .then((r) => r.json())
      .then((cart) => { if (seq === cartOpSeq) renderCart(cart); })
      .catch(() => { if (seq === cartOpSeq) refreshCart(false).catch(() => {}); });
  }

  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-add-to-cart]");
    if (add) { e.preventDefault(); const id = add.getAttribute("data-variant-id"); if (id) { add.disabled = true; addToCart(id).finally(() => (add.disabled = false)); } return; }
    if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); openDrawer(); refreshCart(false); return; }
    if (e.target.closest("[data-cart-close]") || e.target === overlay) { closeDrawer(); return; }
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  /* product form add */
  const pform = $("[data-product-form]");
  /* Preenchido pelo bloco do conjunto (abaixo): oferece o par no popup antes de
     adicionar a peça avulsa. null = produto sem par → fluxo normal. */
  let conjOffer = null;
  if (pform) {
    pform.addEventListener("submit", (e) => {
      e.preventDefault();
      const id = ($("[data-variant-input]", pform) || {}).value;
      const btn = $("[data-atc-submit]", pform);
      if (!id) return;
      if (conjOffer && conjOffer.eligible()) { conjOffer.open(id); return; }
      btn && (btn.disabled = true);
      addToCart(id, 1).finally(() => btn && (btn.disabled = false));
    });
    /* ---------- "Pronto pra comprar": pulso no botão quando o tamanho é escolhido ----------
       O operador pediu isso no botão de pagamento do CHECKOUT — impossível no plano Basic
       (a Shopify não permite CSS/JS no passo de pagamento; só Plus). Aqui é o equivalente
       no ponto que EU controlo: escolher o tamanho é o campo que destrava a compra, então
       o botão pulsa uma vez e ganha um brilho, sinalizando "agora pode clicar".
       Dispara só em clique HUMANO (e.isTrusted) e 1x por escolha — nunca no load. */
    (function () {
      const atc = $("[data-atc-submit]", pform);
      if (!atc) return;
      if (!document.getElementById("nb-ready-css")) {
        const st = document.createElement("style");
        st.id = "nb-ready-css";
        st.textContent =
          "@keyframes nb-ready{0%{transform:scale(1);box-shadow:0 0 0 0 rgba(22,163,74,.5)}" +
          "45%{transform:scale(1.035);box-shadow:0 0 0 10px rgba(22,163,74,0)}" +
          "100%{transform:scale(1);box-shadow:0 0 0 0 rgba(22,163,74,0)}}" +
          ".nb-ready{animation:nb-ready .75s ease-out 2}" +
          "@media (prefers-reduced-motion: reduce){.nb-ready{animation:none;outline:2px solid rgba(22,163,74,.55);outline-offset:2px}}";
        document.head.appendChild(st);
      }
      const pulsar = () => {
        atc.classList.remove("nb-ready");
        void atc.offsetWidth;   /* reflow: reinicia a animação se clicar em outro tamanho */
        atc.classList.add("nb-ready");
      };
      pform.addEventListener("change", (e) => {
        if (!e.isTrusted) return;
        if (!e.target.closest("[data-option]")) return;
        setTimeout(pulsar, 30);   /* depois do handler que troca a variante */
      });
    })();

    // variant selection
    const variants = (() => { try { return JSON.parse($("[data-variants]").textContent); } catch (_) { return []; } })();
    const optionEls = $$("[data-option]", pform);
    if (optionEls.length) {
      pform.addEventListener("change", () => {
        const chosen = [];
        const groups = {};
        optionEls.forEach((el) => { if (el.checked) groups[el.name] = el.value; });
        Object.keys(groups).sort().forEach((k) => chosen.push(groups[k]));
        const match = variants.find((v) => JSON.stringify(v.options) === JSON.stringify(chosen)) || variants.find((v) => v.available);
        if (match) {
          $("[data-variant-input]", pform).value = match.id;
          /* avulsos: variante tem foto propria -> galeria acompanha a cor */
          const fi = match.featured_image && match.featured_image.src;
          const mainImg = $("[data-product-main]");
          if (fi && mainImg) mainImg.src = fi;
        }
        const corSel = optionEls.find((el) => el.checked && el.hasAttribute("data-opt-cor"));
        const corNome = $("[data-cor-nome]");
        if (corSel && corNome) corNome.textContent = corSel.value;
      });
    }
  }

  /* ---------- Compre o conjunto (página de produto) ----------
     Adiciona a peça atual + a peça irmã (metafield custom.conjunto) no MESMO tamanho.
     O tamanho vem do option1 da variante selecionada no form; o par é casado pelo
     option1 igual. Sem tamanho no par → botão desabilita (nunca adiciona errado). */
  const conjunto = $("[data-conjunto]");
  if (conjunto && pform) {
    const cjBtn = $("[data-conjunto-add]", conjunto);
    let cjVars = [];
    try { cjVars = JSON.parse($("[data-conjunto-variants]", conjunto).textContent); } catch (_) {}
    const curVars = (() => { try { return JSON.parse($("[data-variants]").textContent); } catch (_) { return []; } })();

    const parDaVez = () => {
      const curId = parseInt(($("[data-variant-input]", pform) || {}).value, 10);
      const cur = curVars.find((v) => v.id === curId);
      const tam = cur ? cur.options[0] : null;
      return { tam: tam, par: cjVars.find((v) => v.opt === tam) };
    };
    const syncBtn = () => {
      const { par } = parDaVez();
      const ok = !!(par && par.disp);
      cjBtn.disabled = !ok;
      cjBtn.textContent = ok ? cjBtn.getAttribute("data-label-ok") : cjBtn.getAttribute("data-label-out");
    };
    pform.addEventListener("change", () => setTimeout(syncBtn, 0));
    syncBtn();

    const addConjunto = (curId, parId) => {
      openDrawer();
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: curId, quantity: 1 }, { id: parId, quantity: 1 }] }),
      })
        .then((r) => r.json())
        .then(() => refreshCart(true))
        .catch(() => { window.location.href = "/cart"; });
    };

    cjBtn.addEventListener("click", () => {
      const curId = parseInt(($("[data-variant-input]", pform) || {}).value, 10);
      const { par } = parDaVez();
      if (!curId || !par || !par.disp) return;
      cjBtn.disabled = true;
      addConjunto(curId, par.id).finally(() => { cjBtn.disabled = false; syncBtn(); });
    });

    /* ---- Popup de resgate do conjunto ----
       Dispara quando o cliente adiciona a peça AVULSA e o par tem o tamanho.
       Qualquer saída que não seja "Levar o conjunto" adiciona a avulsa mesmo assim —
       o popup nunca segura a venda. 1x por carregamento (anti-chatice). */
    const pop = $("[data-conjunto-popup]");
    if (pop) {
      let popShown = false;
      let pendingId = null;
      const popClose = () => pop.classList.add("hidden");
      const addSingle = () => {
        popClose();
        if (pendingId) { const id = pendingId; pendingId = null; addToCart(id, 1); }
      };
      conjOffer = {
        eligible: () => { const { par } = parDaVez(); return !popShown && !!(par && par.disp); },
        open: (id) => { popShown = true; pendingId = parseInt(id, 10); pop.classList.remove("hidden"); },
      };
      $("[data-conjunto-popup-both]", pop).addEventListener("click", () => {
        const { par } = parDaVez();
        popClose();
        const id = pendingId; pendingId = null;
        if (id && par && par.disp) { addConjunto(id, par.id); } else if (id) { addToCart(id, 1); }
      });
      $("[data-conjunto-popup-single]", pop).addEventListener("click", addSingle);
      $("[data-conjunto-popup-overlay]", pop).addEventListener("click", addSingle);
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && !pop.classList.contains("hidden")) addSingle();
      });
    }
  }

  /* ---------- Mobile nav ---------- */
  const navToggle = $("[data-menu-toggle]");
  const mobileNav = $("[data-mobile-nav]");
  navToggle && navToggle.addEventListener("click", () => mobileNav && mobileNav.classList.toggle("hidden"));

  /* ---------- Product gallery ---------- */
  const galleryThumbs = $$("[data-product-thumb]");
  /* brand-*, não gold-*: o tema herdou as classes da AF Nutrition, onde o token era
     `gold`. Aqui ele se chama `brand` — as classes gold não existem no CSS compilado,
     então a miniatura ativa não recebia destaque nenhum. */
  const galleryActive = ["border-brand-500", "ring-1", "ring-brand-400"];
  const galleryInactive = ["border-ink/8"];
  galleryThumbs.forEach((btn) =>
    btn.addEventListener("click", () => {
      const main = $("[data-product-main]");
      if (main) main.src = btn.getAttribute("data-product-thumb");
      galleryThumbs.forEach((t) => {
        t.classList.remove(...galleryActive);
        t.classList.add(...galleryInactive);
      });
      btn.classList.remove(...galleryInactive);
      btn.classList.add(...galleryActive);
    })
  );

  /* ---------- Galeria: troca automática + setas prev/próxima na foto principal ---------- */
  if (galleryThumbs.length > 1) {
    let gIdx = 0;
    /* Rola SÓ a tira horizontal de miniaturas. O scrollIntoView antigo também rolava a
       PÁGINA (block:nearest puxa o scroll vertical quando a tira está fora da tela) — com
       o autoplay de 4s a página voltava sozinha pra galeria enquanto o cliente lia a
       descrição. */
    const scrollThumb = () => {
      const t = galleryThumbs[gIdx];
      if (!t) return;
      let strip = t.parentElement;
      while (strip && strip !== document.body && strip.scrollWidth <= strip.clientWidth + 4) strip = strip.parentElement;
      if (!strip || strip === document.body || strip === document.documentElement) return;
      const left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: "smooth" });
    };
    const goTo = (i) => {
      gIdx = (i + galleryThumbs.length) % galleryThumbs.length;
      galleryThumbs[gIdx].click();
      scrollThumb();
    };
    /* Autoplay só com a galeria visível e a aba ativa — fora disso o timer para
       (não gasta main thread nem "anda sozinho" fora da tela). */
    let gTimer = null, gInView = true;
    const startTimer = () => { if (!gTimer && gInView && !document.hidden) gTimer = setInterval(() => goTo(gIdx + 1), 4000); };
    const stopTimer = () => { clearInterval(gTimer); gTimer = null; };
    const resetTimer = () => { stopTimer(); startTimer(); };
    const galleryRoot = $("[data-product-main]") || galleryThumbs[0];
    if ("IntersectionObserver" in window && galleryRoot) {
      gInView = false;
      new IntersectionObserver((entries) => {
        gInView = entries[0].isIntersecting;
        gInView ? startTimer() : stopTimer();
      }, { threshold: 0.15 }).observe(galleryRoot);
    }
    document.addEventListener("visibilitychange", () => { document.hidden ? stopTimer() : startTimer(); });
    startTimer();
    galleryThumbs.forEach((btn, i) =>
      btn.addEventListener("click", (e) => {
        if (e.isTrusted) { gIdx = i; resetTimer(); scrollThumb(); }
      })
    );
    // setas prev/próxima sobre a foto grande (trocam a imagem principal; a tira acompanha)
    const mImg = $("[data-product-main]");
    const mWrap = mImg && mImg.closest(".relative");
    if (mWrap) {
      if (!document.getElementById("nb-mainnav-css")) {
        const st = document.createElement("style");
        st.id = "nb-mainnav-css";
        st.textContent = ".nb-mainnav{position:absolute;top:50%;transform:translateY(-50%);z-index:5;display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:9999px;background:rgba(255,255,255,.92);color:#0c0c0e;border:1px solid rgba(12,12,14,.1);box-shadow:0 2px 10px rgba(0,0,0,.14);cursor:pointer;padding:0;transition:background .15s;}.nb-mainnav:hover{background:#fff;}.nb-mainnav.l{left:10px;}.nb-mainnav.r{right:10px;}";
        document.head.appendChild(st);
      }
      const mk = (c, l, p) => {
        const b = document.createElement("button");
        b.type = "button"; b.className = "nb-mainnav " + c; b.setAttribute("aria-label", l);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + p + '"/></svg>';
        return b;
      };
      const bL = mk("l", "Imagem anterior", "m15 6-6 6 6 6"), bR = mk("r", "Próxima imagem", "m9 6 6 6-6 6");
      bL.addEventListener("click", () => { goTo(gIdx - 1); resetTimer(); });
      bR.addEventListener("click", () => { goTo(gIdx + 1); resetTimer(); });
      mWrap.appendChild(bL); mWrap.appendChild(bR);
    }
  }

  /* ---------- Filtros da coleção: só um <details> aberto por vez ---------- */
  const filterDetails = $$("[data-filter-details]");
  if (filterDetails.length) {
    filterDetails.forEach((d) =>
      d.addEventListener("toggle", () => {
        if (d.open) filterDetails.forEach((o) => { if (o !== d) o.open = false; });
      })
    );
    document.addEventListener("click", (e) => {
      filterDetails.forEach((d) => {
        if (d.open && !d.contains(e.target)) d.open = false;
      });
    });
  }

  /* ---------- Carrossel de vitrine (setas) ---------- */
  $$("[data-car-track]").forEach((track) => {
    const wrap = track.parentElement;
    const prev = wrap.querySelector("[data-car-prev]");
    const next = wrap.querySelector("[data-car-next]");
    const step = () => Math.max(240, Math.round(track.clientWidth * 0.8));
    prev && prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    next && next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  });

  /* ---------- Hero slider (dissolve/crossfade) ---------- */
  const hero = $("[data-hero]");
  if (hero) {
    const track = $("[data-hero-track]", hero);
    const slides = $$("[data-hero-slide]", hero);
    const dots = $$("[data-hero-dot]", hero);
    let i = 0, timer = null;
    const n = slides.length;
    const autoplay = parseInt(hero.getAttribute("data-autoplay") || "7", 10);
    const FADE_MS = 700;

    /* bg-white / bg-white/50: idem — `bg-gold-400` não existe neste tema e o dot ativo
       ficava invisível. Branco funciona sobre a arte do banner fullframe. */
    function updateDots() {
      dots.forEach((d, k) => {
        d.classList.toggle("w-7", k === i); d.classList.toggle("bg-white", k === i);
        d.classList.toggle("w-2", k !== i); d.classList.toggle("bg-white/50", k !== i);
      });
    }
    function settle() {
      slides.forEach((s, k) => {
        const active = k === i;
        s.style.transition = "none";
        s.style.opacity = active ? "1" : "0";
        s.style.zIndex = active ? "1" : "0";
        s.style.pointerEvents = active ? "auto" : "none";
      });
    }
    function go(idx) {
      const next = ((idx % n) + n) % n;
      if (next === i) return;
      const to = slides[next];
      to.style.transition = "none";
      to.style.zIndex = "2";
      to.style.pointerEvents = "auto";
      to.style.opacity = "0";
      void to.offsetHeight;
      to.style.transition = "opacity " + FADE_MS + "ms ease-out";
      to.style.opacity = "1";
      i = next;
      updateDots();
      clearTimeout(go._t);
      go._t = setTimeout(settle, FADE_MS + 20);
    }
    function start() { if (n > 1 && autoplay > 0) timer = setInterval(() => go(i + 1), autoplay * 1000); }
    function stop() { clearInterval(timer); }
    $("[data-hero-prev]", hero) && $("[data-hero-prev]", hero).addEventListener("click", () => { go(i - 1); stop(); start(); });
    $("[data-hero-next]", hero) && $("[data-hero-next]", hero).addEventListener("click", () => { go(i + 1); stop(); start(); });
    dots.forEach((d, k) => d.addEventListener("click", () => { go(k); stop(); start(); }));

    /* swipe / arrastar no touch — dissolve acompanha o dedo em tempo real */
    if (n > 1) {
      let dragging = false, startX = 0, startY = 0, axisLocked = "", widthPx = 0, dragDir = 0, dragTarget = null, dragTargetIdx = -1;
      track.addEventListener("touchstart", (e) => {
        dragging = true; axisLocked = ""; dragDir = 0; dragTarget = null;
        startX = e.touches[0].clientX; startY = e.touches[0].clientY;
        widthPx = hero.getBoundingClientRect().width;
        stop();
      }, { passive: true });
      track.addEventListener("touchmove", (e) => {
        if (!dragging) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (!axisLocked) axisLocked = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
        if (axisLocked !== "x") return;
        const dir = dx < 0 ? 1 : -1;
        if (dir !== dragDir) {
          if (dragTarget) {
            dragTarget.style.transition = "none";
            dragTarget.style.opacity = "0";
            dragTarget.style.pointerEvents = "none";
            dragTarget.style.zIndex = "0";
          }
          dragDir = dir;
          dragTargetIdx = ((i + dir) % n + n) % n;
          dragTarget = slides[dragTargetIdx];
          dragTarget.style.transition = "none";
          dragTarget.style.zIndex = "2";
          dragTarget.style.pointerEvents = "none";
        }
        const amount = Math.min(1, Math.abs(dx) / widthPx);
        dragTarget.style.opacity = String(amount);
      }, { passive: true });
      function onDragEnd() {
        if (!dragging) return;
        dragging = false;
        if (axisLocked === "x" && dragTarget) {
          const amount = parseFloat(dragTarget.style.opacity || "0");
          if (amount >= 0.28) {
            const targetIdx = dragTargetIdx;
            dragTarget.style.transition = "opacity 220ms ease-out";
            dragTarget.style.opacity = "1";
            i = targetIdx;
            updateDots();
            clearTimeout(go._t);
            go._t = setTimeout(settle, 240);
          } else {
            const cancelTarget = dragTarget;
            cancelTarget.style.transition = "opacity 220ms ease-out";
            cancelTarget.style.opacity = "0";
            setTimeout(() => { cancelTarget.style.pointerEvents = "none"; cancelTarget.style.zIndex = "0"; }, 220);
          }
        }
        dragTarget = null; dragDir = 0;
        start();
      }
      track.addEventListener("touchend", onDragEnd);
      track.addEventListener("touchcancel", onDragEnd);
    }

    updateDots();
    start();
  }

  /* ---------- Lead capture (10% OFF ao adicionar ao carrinho) ----------
     Submit é form nativo do Shopify ({% form 'contact' %}, ver snippet) — a loja
     tem hCaptcha no formulário de contato, então NÃO dá pra interceptar via fetch
     (retorna 400 "Missing CAPTCHA token"). O submit recarrega a página; a etapa do
     cupom reabre sozinha via form.posted_successfully? (atributo data-lead-auto-open). */
  const leadModal = $("[data-lead-modal]");
  const LEAD_STORAGE_KEY = "nb_lead_seen";

  if (leadModal) {
    const overlay = $("[data-lead-overlay]", leadModal);
    const panel = $("[data-lead-panel]", leadModal);
    const stepForm = $('[data-lead-step="form"]', leadModal);
    const stepCoupon = $('[data-lead-step="coupon"]', leadModal);
    const submitBtn = $("[data-lead-submit]", leadModal);
    const submitLabel = $("[data-lead-submit-label]", leadModal);
    const copyBtn = $("[data-lead-copy]", leadModal);
    const codeEl = $("[data-lead-coupon-code]", leadModal);
    const copiedMsg = $("[data-lead-copied-msg]", leadModal);
    const form = document.getElementById("nb-lead-capture-form");
    const daySel = $("[data-lead-day]", leadModal);
    const monthSel = $("[data-lead-month]", leadModal);
    const yearSel = $("[data-lead-year]", leadModal);
    const birthdayHidden = $("[data-lead-birthday-hidden]", leadModal);

    function syncBirthday() {
      if (!birthdayHidden) return;
      const bday = [daySel && daySel.value, monthSel && monthSel.value, yearSel && yearSel.value].filter(Boolean).join("/");
      birthdayHidden.value = bday ? "aniversario-" + bday : "";
    }
    [daySel, monthSel, yearSel].forEach((el) => el && el.addEventListener("change", syncBirthday));

    let leadHideTimer = null;
    function openLeadModal() {
      clearTimeout(leadHideTimer);
      leadOpen = true;
      leadModal.classList.remove("hidden", "pointer-events-none");
      requestAnimationFrame(() => {
        overlay && overlay.classList.remove("opacity-0");
        panel && panel.classList.remove("opacity-0", "scale-95");
      });
      syncBodyLock();
    }
    function closeLeadModal() {
      leadOpen = false;
      overlay && overlay.classList.add("opacity-0");
      panel && panel.classList.add("opacity-0", "scale-95");
      syncBodyLock();
      clearTimeout(leadHideTimer);
      leadHideTimer = setTimeout(() => leadModal.classList.add("hidden", "pointer-events-none"), 300);
      try { localStorage.setItem(LEAD_STORAGE_KEY, "1"); } catch (_) {}
    }
    maybeShowLeadModal = function () {
      let seen = null;
      try { seen = localStorage.getItem(LEAD_STORAGE_KEY); } catch (_) {}
      if (seen) return;
      openLeadModal();
    };

    leadModal.addEventListener("click", (e) => {
      if (e.target.closest("[data-lead-close]") || e.target === overlay) closeLeadModal();
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !leadModal.classList.contains("hidden")) closeLeadModal(); });

    form && form.addEventListener("submit", () => {
      submitBtn.disabled = true;
      submitLabel.textContent = "Enviando...";
    });

    copyBtn && copyBtn.addEventListener("click", () => {
      const code = (codeEl.textContent || "").trim();
      const done = () => {
        copiedMsg.style.visibility = "visible";
        setTimeout(() => { copiedMsg.style.visibility = "hidden"; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });

    /* Normaliza scrollRestoration em toda pagina (auto = default do navegador). Tambem cura
       abas que ficaram travadas em 'manual' por uma versao anterior deste fix. */
    if ("scrollRestoration" in history) history.scrollRestoration = "auto";
    const autoOpen = leadModal.getAttribute("data-lead-auto-open");
    if (autoOpen) {
      /* Fix: o form nativo (form 'customer') recarrega a pagina com a ancora #nb-lead-capture-form
         e o navegador rola ate o form (perto do rodape). Remove a ancora da URL e volta ao topo. */
      if (location.hash) { try { history.replaceState(null, "", location.pathname + location.search); } catch (_) {} }
      window.scrollTo(0, 0);
    }
    if (autoOpen === "coupon") {
      stepForm.classList.add("hidden");
      stepCoupon.classList.remove("hidden");
      openLeadModal();
      try { localStorage.setItem(LEAD_STORAGE_KEY, "1"); } catch (_) {}
    } else if (autoOpen === "form-error") {
      openLeadModal();
    }
  }

  /* ---------- Busca preditiva (expande do ícone, resultados ao vivo) ---------- */
  (function () {
    const toggle = $("[data-search-toggle]");
    const panel = $("[data-search-panel]");
    if (!toggle || !panel) return;
    const input = $("[data-search-input]", panel);
    const results = $("[data-search-results]", panel);
    const closeBtn = $("[data-search-close]", panel);
    let timer;

    const fmtPrice = (p) => "R$ " + Number(p).toFixed(2).replace(".", ",");
    const clearResults = () => { results.classList.add("hidden"); results.innerHTML = ""; };

    function openPanel() {
      panel.classList.remove("hidden");
      toggle.setAttribute("aria-expanded", "true");
      setTimeout(() => input && input.focus(), 30);
    }
    function closePanel() {
      panel.classList.add("hidden");
      toggle.setAttribute("aria-expanded", "false");
      clearResults();
    }

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      panel.classList.contains("hidden") ? openPanel() : closePanel();
    });
    closeBtn && closeBtn.addEventListener("click", closePanel);
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !panel.classList.contains("hidden")) closePanel(); });
    document.addEventListener("click", (e) => {
      if (!panel.classList.contains("hidden") && !panel.contains(e.target) && !toggle.contains(e.target)) closePanel();
    });

    input && input.addEventListener("input", () => {
      const q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { clearResults(); return; }
      timer = setTimeout(() => {
        const url = "/search/suggest.json?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } })
          .then((r) => r.json())
          .then((j) => {
            const prods = (j.resources && j.resources.results && j.resources.results.products) || [];
            if (!prods.length) {
              results.innerHTML = '<p class="px-4 py-5 text-center text-[13px] text-ink/50">Nenhum produto encontrado.</p>';
            } else {
              results.innerHTML = prods.map((p) =>
                '<a href="' + p.url + '" class="flex items-center gap-3 px-4 py-2.5 transition hover:bg-sand/50">' +
                  '<span class="block h-12 w-12 shrink-0 overflow-hidden rounded-lg bg-sand/40">' +
                    (p.image ? '<img src="' + p.image + '" alt="" class="h-full w-full object-cover" loading="lazy">' : "") +
                  "</span>" +
                  '<span class="flex-1 text-[14px] font-medium leading-tight text-ink line-clamp-2">' + p.title + "</span>" +
                  (p.price ? '<span class="shrink-0 text-[13px] font-bold text-ink">' + fmtPrice(p.price) + "</span>" : "") +
                "</a>"
              ).join("") +
              '<a href="/search?q=' + encodeURIComponent(q) + '&type=product" class="block border-t border-ink/10 px-4 py-3 text-center text-[13px] font-semibold text-brand-600 transition hover:bg-sand/50">Ver todos os resultados</a>';
            }
            results.classList.remove("hidden");
          })
          .catch(() => clearResults());
      }, 250);
    });
  })();

  /* ---------- Watchdog anti-congelamento ----------
     Cura os dois estados que já congelaram a loja (13/08 e 18-19/08), venham de onde
     vierem: (a) drawer visível mas surdo a clique (pointer-events none herdado de
     markup em cache); (b) body preso em overflow:hidden sem NENHUM overlay nosso
     aberto. Barato (roda a cada 2.5s) e não interfere em overlay de app de terceiro. */
  setInterval(() => {
    if (!drawer) return;
    const drawerVisivel = !drawer.classList.contains("hidden");
    if (drawerVisivel && getComputedStyle(drawer).pointerEvents === "none") {
      drawer.classList.remove("pointer-events-none");
    }
    if (!drawerOpen && !leadOpen && document.body.style.overflow === "hidden") {
      const leadEl = document.querySelector("[data-lead-modal]");
      const leadVisivel = leadEl && !leadEl.classList.contains("hidden");
      if (!drawerVisivel && !leadVisivel) document.body.style.overflow = "";
    }
  }, 2500);

  /* Volta do checkout pelo botão VOLTAR (bfcache): a página é restaurada congelada no
     estado antigo. Fecha o drawer e libera a rolagem pra nunca voltar travado. */
  window.addEventListener("pageshow", (e) => { if (e.persisted) closeDrawer(); });

  /* sincroniza contador no load */
  if (document.querySelector("[data-cart-count]")) refreshCart(false);
})();
